<template>
  <mdb-container class="gp-has-header">
    <div v-if="fromPub">
      <mdb-btn @click="pubHome" icon="home">Back</mdb-btn>
    </div>
    <mdb-input @input="isTyping = true"
               placeholder="Search" type="text" v-model="query"
    />

    <div v-if="query && searchResults.length == 0">Nothing found.</div>

    <div v-if="searchResults.length==0">
      <mdb-card :key="i" class="mb-4" v-for="(f,i) in faq">
        <mdb-card-header class="secondary-color text-left">
          <h5>{{f.category}}</h5>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <mdb-accordion :panes="f.panes" material></mdb-accordion>
        </mdb-card-body>
      </mdb-card>
    </div>

    <div v-if="searchResults.length>0">
      <mdb-card>
        <mdb-card-body>
          <mdb-btn @click="clearResults" icon="arrow-left">Back</mdb-btn>
          <h4>Search Results</h4>
          <div :key="i" class="text-left" v-for="(r,i) in searchResults">
            <a @click.prevent="viewPage(r)" href="">{{r.title}}</a>
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>

    <mdb-modal v-if="showViewer" @close="showViewer = false" info position="top-center"
               scrollable size="lg">
      <mdb-modal-header>
        <p class="heading">{{currentDocument.title}}</p>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="text-left" v-html="currentDocument.content"/>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import {
  mdbAccordion,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader
} from 'mdbvue';

export default {
    name: 'Explore',
    components: {
      mdbAccordion,
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbInput,
      mdbBtn
    },
    data() {
      return {
        faq: [],
        fromPub: false,
        isTyping: false,
        query: "",
        searchResults: [],
        showViewer: false,
        currentDocument: null
      }
    },
    watch: {
      query: _.debounce(function () {
        this.isTyping = false;
      }, 300),
      isTyping: function (value) {
        if (!value && this.query) {
          this.doSearch()
        }
      }
    },
    mounted() {
      if (this.$route.query.src == "pub") this.fromPub = true
      this.loadData()
    },
    methods: {
      viewPage(p) {
        this.currentDocument = p
        this.showViewer = true
      },
      pubHome() {
        window.open(this.settings.staticSiteUrl)
      },
      clearResults() {
        this.searchResults = []
        this.query = ""
      },
      doSearch() {
        this.$store.dispatch("setExecuting", false)
        let url = "/public/faq/?q=" + this.query
        api.get(url).then(
          (results) => {
            this.searchResults = results.data
          },
          (error) => {
            this.$notify.error({message: "Error fetching page.", timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      loadData() {
        this.$store.dispatch("setExecuting", false)
        let url = "/public/faq/"
        api.get(url).then(
          (results) => {
            this.faq = results.data
          },
          (error) => {
            this.$notify.error({message: "Error fetching page.", timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }
    }

  };
</script>
